var exports = {
  "yJ": "xa15a2ab7--9209eb--links",
  "$U": "xa15a2ab7--9209eb--link-item",
  "vu": "xa15a2ab7--9209eb--active",
  "Gd": "xa15a2ab7--9209eb--social-links",
  "vk": "xa15a2ab7--9209eb--vk",
  "ok": "xa15a2ab7--9209eb--ok",
  "W1": "xa15a2ab7--9209eb--input-link",
};

module.exports = exports;
